import { createContext, useContext } from 'react';
import type { ImageLoadingStatus } from './types';

export interface AvatarContextValue {
    status: ImageLoadingStatus;
    setStatus: (status: ImageLoadingStatus) => void;
    bgColor?: string;
}

export const AvatarContext = createContext<AvatarContextValue | null>(null);

export const useAvatarContext = (component: string): AvatarContextValue => {
    const ctx = useContext(AvatarContext);
    if (!ctx) {
        throw new Error(`<${component}> must be rendered inside <Avatar>`);
    }

    return ctx;
};
